import { useState, useEffect } from 'react';
import { authenticatedFetch } from '../utils/authenticatedFetch';

export function useExpectedData(storeName, validationResults) {
    const [expectedData, setExpectedData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const hasValidExpectedData = validationResults?.expectedData &&
            (validationResults.expectedData.proofreading?.offers?.length > 0 ||
                validationResults.expectedData.proofreading?.tracking ||
                validationResults.expectedData.proofreading?.counties?.counties?.length > 0);

        if (hasValidExpectedData) {
            setExpectedData(validationResults.expectedData);
            setLoading(false);
        } else {
            fetchExpectedData();
        }
    }, [storeName, validationResults]);

    const fetchExpectedData = async () => {
        setLoading(true);
        try {
            const response = await authenticatedFetch(`/api/stores/${encodeURIComponent(storeName)}/proofreading-data`);
            if (response.ok) {
                const data = await response.json();
                setExpectedData(data);
            }
        } catch (error) {
            console.error('Error fetching expected data:', error);
        } finally {
            setLoading(false);
        }
    };

    return { expectedData, loading, refetch: fetchExpectedData };
}
